<template>
  <div id="font-menu">
    <div class="letters" style=" height:48px;">
      <letters :letters="letters" :selectedLetter="selectedLetter" @setLetter="setLetter"></letters>
    </div>
    <letter-options :selectedLetter="selectedLetter" v-for="letter in letters"
                    v-if="letter.id==selectedLetter.id"
                    :key="letter.id" @setSync="setSync">
    </letter-options>
    <div class="footer">
      <div class="footer-container">
        <button class="next-button" @click="$router.push({name: 'estimate'})">次へ</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import axios from 'axios/dist/axios.min'
  import LetterOptions from './font/LetterOptions.vue'
  import Letters from './font/Letters.vue'

  export default {
    name: 'font-menu',
    components: {
      Letters, LetterOptions
    },
    data(){
      return {
        letters: [],
        selectedLetter: null,
        decoration_parts: [{name:'文字色'}],
        sync: {},
      }
    },
    computed: {
      ...mapState(['cart']),
      design_id(){
        return this.$store.state.cart.design.id;
      },
      selectedDesign () {
        return this.cart.design;
      },
    },
    methods: {
      initialize () {
        if (!this.selectedDesign) {
          this.$router.push({name: 'category'});
        }
        this.setLetters();
        if (this.$store.state.fonts.length === 0) {
          axios.get('/fonts.json').then(response => {
            this.$store.commit('setFonts', response.data.fonts);
          });
        }
      },
      setLetter(letter){
        if (!letter) return;
        this.selectedLetter = letter;
        if (this.selectedLetter) {
          this.$emit('setMarquee', this.selectedLetter.name + 'が必用な場合は位置、文字種、番号、プリント色を選択してください。');
        }
      },
      setSync(payload){
        for (let i = 0; i < this.letters.length; i++) {
          if (this.letters[i].sync_code == this.selectedLetter.sync_code){
            this.$store.commit('setWord', {letter_id: this.letters[i].id, word: payload.word});
            this.$store.commit('setCartLetterFont', [this.letters[i], payload.selectedFont]);
          }
        }
      },
      setLetters(){
        // this.letters = [];
        if (this.$store.state.cart.letters.length) {
          this.letters = this.$store.state.cart.letters;
          for (let i = 0; i < this.letters.length; i++) {
            // 同期
            if (this.letters[i].sync_code){
              this.sync[this.letters[i].sync_code] = this.letters[i].word;
            }
          }
          this.setLetter(this.$store.state.cart.letters[0]);
        } else {
          this.$store.commit('setLoading');
          axios.get('/letters.json?design_id='+this.selectedDesign.id).then( response => {
            for (let i = 0; i < response.data.letters.length; i++) {
              this.letters.push(response.data.letters[i]);
              // 同期
              if (this.letters[i].sync_code){
                this.sync[this.letters[i].sync_code] = this.letters[i].word;
              }
            }
            this.setLetter(response.data.letters[0]);
            this.$store.commit('setCartLetters', response.data.letters);
            this.$store.commit('resetLoading');
          });
        }
      }
    },
    created (){
      this.initialize();
    },
    deactivated(){
      this.$store.commit('resetLoading');
    },
    watch: {
      selectedDesign: function() {
        if (this.cart.design && this.cart.parts.length === 0){
          this.initialize();
        }
      }
    }
  }
</script>

<!-- @todo fontの読み込みは動的に行っていない。フォント名に.があった場合はあらかじめ削除している。 -->
<style lang="scss">
  #font-menu .swiper, #font-menu .marquee {
    background-color: inherit;
  }
  .letters {
    background-color: lighten(#151d66, 10%);
  }
</style>
<style lang="scss" scoped>
  #font-menu {
    padding-bottom: 4rem;
  }
  .footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #fff;
    background-color: #151d66;
    z-index: 1001;
    .footer-container {
      padding: 5px;
      height: 36px;
      text-align: center;

      button {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
</style>
